import Espot from './Espot'

export { EspotReducer } from './EspotState'
export default Espot